import {
  canUseElectronRuntimeTransport,
  createElectronRuntimeTransport,
} from "./electron-runtime-transport";
import {
  createGatewayRuntimeTransport,
  type GatewayRuntimeTransportOptions,
} from "./gateway-runtime-transport";
import type {
  RuntimeTransport,
  RuntimeTransportLifecycleOptions,
} from "./runtime-transport";

type GatewayConnectionOptions = Pick<
  GatewayRuntimeTransportOptions,
  "url" | "token" | "password" | "resolveConnection"
>;

export type RuntimeTransportFactoryOptions =
  RuntimeTransportLifecycleOptions & {
    gateway?: GatewayConnectionOptions;
    preferElectronRuntime?: boolean;
  };

export function createRuntimeTransport(
  options: RuntimeTransportFactoryOptions,
): RuntimeTransport {
  const gateway = options.gateway;
  const lifecycleOptions: RuntimeTransportLifecycleOptions = {
    clientName: options.clientName,
    clientVersion: options.clientVersion,
    platform: options.platform,
    mode: options.mode,
    instanceId: options.instanceId,
    onHello: options.onHello,
    onEvent: options.onEvent,
    onClose: options.onClose,
    onGap: options.onGap,
    diagnosticLogger: options.diagnosticLogger,
  };
  const preferElectronRuntime = options.preferElectronRuntime ?? true;
  if (preferElectronRuntime && lifecycleOptions.instanceId && canUseElectronRuntimeTransport()) {
    const transport = createElectronRuntimeTransport({
      ...lifecycleOptions,
      instanceId: lifecycleOptions.instanceId,
    });
    if (transport) {
      return transport;
    }
  }

  if (!gateway?.url) {
    throw new Error("Gateway connection required when Electron runtime transport is unavailable.");
  }

  return createGatewayRuntimeTransport({
    ...lifecycleOptions,
    ...gateway,
  });
}

export function shouldUseElectronRuntimeTransport(): boolean {
  return canUseElectronRuntimeTransport();
}
